<div class="_text-xl _h-full _flex _flex-col _items-center _center-xy">
    <!-- Loading Spinner and Messages -->
    <ng-container *ngIf="!errorMessage">
        <i class="fas fa-circle-notch fa-spin _z-20"></i>
        <span class="_ml-1 _mt-2">{{ loadingMessages[currentMessageIndex] }}</span>
        <small class="_text-gray-500 _mt-2">{{ funFacts[currentFunFactIndex] }}</small>
    </ng-container>

    <!-- Error Message -->
    <ng-container *ngIf="errorMessage">
        <i class="fas fa-exclamation-triangle _z-20 _text-red-500"></i>
        <span class="_ml-1 _mt-2 _text-red-500">{{ errorMessage }}</span>
    </ng-container>
</div>
